export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  requiredPermission?: string
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'tenant-admin',
      displayName: 'menu.tenant-admin',
      meta: { icon: 'account_tree' },
      children: [
        {
          name: 'tenant-settings',
          displayName: 'menu.tenant-settings',
          children: [
            { name: 'tenant-roles', displayName: 'menu.tenant-roles', requiredPermission: 'Page.Role' },
            {
              name: 'organizational-hierarchy',
              displayName: 'menu.organizational-hierarchy',
              requiredPermission: 'Page.OrganizationHierarchy',
            },
            {
              name: 'organization-employees',
              displayName: 'menu.organization-employees',
              requiredPermission: 'Page.OrganizationEmployee',
            },
            { name: 'tenant-employees', displayName: 'menu.tenant-employees', requiredPermission: 'Page.Employee' },
            {
              name: 'assignable-roles',
              displayName: 'menu.assignable-roles',
              requiredPermission: 'Page.AssignableRole',
            },
            { name: 'role-access', displayName: 'menu.role-access', requiredPermission: 'Page.RoleAccess' },
            {
              name: 'role-assignments',
              displayName: 'menu.role-assignments',
              requiredPermission: 'Page.RoleAssignment',
            },
            { name: 'code-types', displayName: 'menu.code-types', requiredPermission: 'Page.CodeType' },
            { name: 'i18n-keys', displayName: 'menu.i18n-keys', requiredPermission: 'Page.I18nKey' },
            {
              name: 'i18n-translations',
              displayName: 'menu.i18n-translations',
              requiredPermission: 'Page.I18nTranslation',
            },
            {
              name: 'notification-templates',
              displayName: 'menu.notification-templates',
              requiredPermission: 'Page.NotificationTemplate',
            },
            {
              name: 'ticket-status-notification-rules',
              displayName: 'menu.ticket-status-notification-rules',
              requiredPermission: 'Page.TicketStatusNotificationRule',
            },
            { name: 'sequence-numbers', displayName: 'menu.sequence-numbers', requiredPermission: 'Page.SequenceNo' },
            {
              name: 'access-resources',
              displayName: 'menu.access-resources',
              requiredPermission: 'Page.AccessResource',
            },
          ],
        },
        {
          name: 'manage-companies',
          displayName: 'menu.manage-companies',
          requiredPermission: 'Page.Company',
        },
      ],
    },
    {
      name: 'project-management',
      displayName: 'menu.projects',
      meta: {
        icon: 'inventory_2',
      },
      children: [
        {
          name: 'manage-projects',
          displayName: 'menu.manage-projects',
          requiredPermission: 'Page.Project',
        },
        {
          name: 'manage-contracts',
          displayName: 'menu.manage-contracts',
          requiredPermission: 'Page.Contract',
        },
        {
          name: 'manage-tasks',
          displayName: 'menu.manage-tasks',
          requiredPermission: 'Page.ProjectTask',
        },
        {
          name: 'company-contacts',
          displayName: 'menu.company-contacts',
          requiredPermission: 'Page.CompanyContact',
        },
      ],
    },
    {
      name: 'ticket-management',
      displayName: 'menu.tickets',
      meta: {
        icon: 'style',
      },
      children: [
        {
          name: 'manage-tickets',
          displayName: 'menu.manage-tickets',
          requiredPermission: 'Page.Ticket',
        },
        {
          name: 'shopping-list',
          displayName: 'menu.shopping-list',
          requiredPermission: 'Page.ShoppingList',
        },
        {
          name: 'manage-time-logs',
          displayName: 'menu.manage-time-logs',
          requiredPermission: 'Page.TimeLog',
        },
        {
          name: 'manage-invoices',
          displayName: 'menu.manage-invoices',
          requiredPermission: 'Page.Invoice',
        },
        {
          name: 'invoice-queue',
          displayName: 'menu.invoice-queue',
          requiredPermission: 'Page.InvoiceQueue',
        },
        {
          name: 'time-sheets',
          displayName: 'menu.time-sheets',
          requiredPermission: 'Page.TimeSheet',
        },
        {
          name: 'timesheet-reports',
          displayName: 'menu.timesheet-reports',
          requiredPermission: 'Page.TimeSheet',
        },
      ],
    },
    {
      name: 'product-management',
      displayName: 'menu.products',
      meta: {
        icon: 'shopping_cart',
      },
      children: [
        {
          name: 'manage-products',
          displayName: 'menu.manage-products',
          requiredPermission: 'Page.Product',
        },
        {
          name: 'release-tracking',
          displayName: 'menu.release-tracking',
          requiredPermission: 'Page.Release',
        },
        {
          name: 'license-tracking',
          displayName: 'menu.license-tracking',
          requiredPermission: 'Page.License',
        },
        {
          name: 'deployment-tracking',
          displayName: 'menu.deployment-tracking',
          requiredPermission: 'Page.Deployment',
        },
      ],
    },
  ] as INavigationRoute[],
}
